import {
  NUTRITION_PLATFORM_GROWTH_SLUG,
  NUTRITION_PLATFORM_PRO_SLUG,
  NUTRITION_PLATFORM_SLUG,
  NUTRITION_PLATFORM_STARTER_SLUG,
} from "utils/products";

/**
 * The plan a visitor picked on the marketing site (`/signup?product=<slug>`).
 *
 * Signup can't carry it through Auth0: new users must verify their email, get
 * bounced to /welcome, and sign in again from scratch, so every path lands on
 * the dashboard. It is kept in localStorage instead and the dashboard sends the
 * user on to checkout once.
 */
const STORAGE_KEY = "passio.pendingPlan";
const TTL_MS = 7 * 24 * 60 * 60 * 1000;

const TIER_SLUGS = new Set([
  NUTRITION_PLATFORM_STARTER_SLUG,
  NUTRITION_PLATFORM_GROWTH_SLUG,
  NUTRITION_PLATFORM_PRO_SLUG,
]);

export const rememberPendingPlan = (slug: string | null) => {
  if (!slug || (slug !== NUTRITION_PLATFORM_SLUG && !TIER_SLUGS.has(slug))) {
    return;
  }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ slug, at: Date.now() }));
  } catch {
    // Storage unavailable (private mode); the user picks the plan manually.
  }
};

/** Returns where to send the user for their pending plan, and forgets it. */
export const takePendingPlanPath = (): string | null => {
  let raw: string | null = null;
  try {
    raw = localStorage.getItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    return null;
  }
  if (!raw) {
    return null;
  }
  try {
    const { slug, at } = JSON.parse(raw);
    if (typeof at !== "number" || Date.now() - at > TTL_MS) {
      return null;
    }
    if (TIER_SLUGS.has(slug)) {
      return `/manage-subscription?product=${slug}`;
    }
    if (slug === NUTRITION_PLATFORM_SLUG) {
      return `/details?product=${slug}`;
    }
  } catch {
    // Malformed entry; ignore it.
  }
  return null;
};
